module.exports = __webpack_public_path__ + "static/talking-to-strangers-a3186e5f450b7f3c6cbdac29d8cb6bc1.jpg";